import React from 'react';
import { Icon, LANGUAGES_OPTIONS, Selector } from '@web-chat-core/ui-kit';
import i18next from '@web-chat-core/ui-kit/lib/i18n';
import { LogoBlock } from '../Logo/view';
import { Logo } from '../Logo/Logo';
import { HeaderContainerStyled, StyledLogo, StyledSelectorWrapper } from './view';

interface HeaderInternalProps {
    language: string;
    setPersistLanguage: (language: string) => void;
    embeddedMode: boolean;
    isLanguage?: boolean;
}

export const Header: React.FC<HeaderInternalProps> = (props) => {
    const { language, setPersistLanguage, embeddedMode = false, isLanguage = true } = props;
    const activeOption = LANGUAGES_OPTIONS.find((option) => option.value === language);
    const showLanguageSwitch = isLanguage && LANGUAGES_OPTIONS.length > 1;

    const onLangChange = (newValue: { label: string; value: string }): void => {
        setPersistLanguage(newValue.value);
        i18next.changeLanguage(newValue.value);
    };

    return (
        <HeaderContainerStyled>
            <StyledLogo>
                <LogoBlock>
                    <Logo />
                </LogoBlock>
            </StyledLogo>
            {!embeddedMode && showLanguageSwitch && (
                <StyledSelectorWrapper>
                    <Icon icon="icEarth" colorVariant="third" />
                    <Selector
                        withoutBg
                        width={'85px'}
                        menuHeight={250}
                        minMenuHeight={250}
                        options={LANGUAGES_OPTIONS}
                        onChange={onLangChange}
                        value={activeOption}
                    />
                </StyledSelectorWrapper>
            )}
        </HeaderContainerStyled>
    );
};
